module.exports = "/images/blog-banner.jpg?8572f36ec4c4d692b9a5e0acaf60a77f";